const e = {
  filled: {
    borderRadius: "md",
    px: 3,
    py: (t) => t.spacing(1.5)
  },
  ghost: {
    px: 1,
    pt: 3
  }
}, r = {
  filled: {
    mt: 1
  },
  ghost: {
    mt: 3,
    pt: 0
  }
}, o = {
  filled: {
    error: {
      "&": (t) => ({ ...t.outline({ color: "error", radius: "lg" }) })
    }
  }
}, a = {
  textArea: r,
  textAreaWrapper: e,
  textAreaWrapperVariantState: o
};
export {
  a as textAreaTheme
};
